import React from 'react';
import { SearchIconWrapper, SearchInput, SearchWrapper } from '../index.styled';

const SearchBar: React.FC<{ searchTerm: string; setSearchTerm: (term: string) => void; onClear: () => void }> = ({ searchTerm, setSearchTerm, onClear }) => {
    return (
        <SearchWrapper>
            <SearchInput
                type="text"
                placeholder="Enter a member's name..."
                value={searchTerm}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
            />
            <SearchIconWrapper
                as={searchTerm ? 'button' : 'div'}
                onClick={searchTerm ? onClear : undefined}
                style={searchTerm ? { pointerEvents: 'auto', cursor: 'pointer', background: 'none', border: 'none', padding: 0 } : undefined}
                aria-label={searchTerm ? 'Clear search' : undefined}
            >
                {searchTerm ? (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                ) : (
                    <img src="https://members.performancegolf.com/wp-content/uploads/2026/04/svgviewer-png-output.png" alt="Search" width="19" height="19" />
                )}
            </SearchIconWrapper>
        </SearchWrapper>
    );
};

export default SearchBar;